import React from 'react';
import './AdditionalSupportIndicator.css';

export const ADDITIONAL_SUPPORT_COLOR = '#8c52ff';
export const ADDITIONAL_SUPPORT_LABEL = 'Accommodations/modifications applied';

export default function AdditionalSupportIndicator({ applied }: any) {
  if (!applied) return null;
  return <span className="ae-additional-support-dot" role="img" aria-label={ADDITIONAL_SUPPORT_LABEL} title={`${ADDITIONAL_SUPPORT_LABEL}: additional support beyond what everyone received.`} />;
}
